import { colors, ImpFlex, ImpPad, ImpText } from '@imprint-payments/imprint-ui';

import { useAppSelector } from '../../app/hooks';
import { selectLanguage } from '../../app/languageSelectors';

interface InStoreLabelsProps {
  storeNum: string | null;
  employeeId: string | null;
}

export function InStoreLabels({ storeNum, employeeId }: InStoreLabelsProps) {
  const language = useAppSelector(selectLanguage);

  return (
    <ImpFlex direction="row" fluid>
      <ImpPad padding="16px 0px" fluid>
        <ImpFlex direction="column" align="flex-start">
          <ImpText typography="body3" color={colors.content.onSurfaceVariant}>
            {language.storeNumLabel}
          </ImpText>
          <ImpText>{storeNum}</ImpText>
        </ImpFlex>
      </ImpPad>

      <ImpPad padding="16px 0px" fluid>
        <ImpFlex direction="column" align="flex-start">
          <ImpText typography="body3" color={colors.content.onSurfaceVariant}>
            {language.employeeIdLabel}
          </ImpText>
          <ImpText>{employeeId}</ImpText>
        </ImpFlex>
      </ImpPad>
    </ImpFlex>
  );
}
